export const nr=2;
export const ng=3;
export const nb=5;

